// Tolerance of words that the highlighted area can be + / - within

export const WORD_TOLERANCE = 5;
